/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, Module) {
	'use strict';

	/**
	 *
	 * Subscribes to channels: [EcommerceProductDataHub]
	 * Listens to channel events: [startProductDataSubscription, invalidateProductData]
	 * Triggers channel events: [subscribeForProductData]
	 *
	 * @namespace Tc.Module
	 * @class PromoBadge
	 * @extends Tc.Module
	 */
	Module.PromoBadge = Module.extend({

		on: function(callback) {
			/*
			  ATTENTION
			  This module is auto-initialized only, if the component configured to use a E-Commerce Data Hub
			  to retrieve its data. Otherwise this component does not require JS to function properly.
			 */
			var	mod = this;

			mod.$textfield = mod.$ctx.find('.textfield');
			mod.defaultText = mod.$textfield.text();

			callback();
		},

		after: function() {
			this.sandbox.application.registry.EcommerceProductDataHub.module.simpleSubscribe(this, this.gotDataFromHub);
		},

		/**
		 * Channel listener which gets called by EcommerceProductDataHub to notify about data changes.
		 *
		 * @method onInvalidateProductData
		 * @param {Object} data See EcommerceProductDataHub for details about the structure
		 * @return void
		 */
		gotDataFromHub: function(info) {
			var mod = this;
			var promotion = null;
			if(info && info.product) {
				var promos = info.product.getApplicablePromotions(
					info.subscriptionId,
					info.subscriptionDuration,
					info.subscriptionType
				).filter(function(promo) {
					return promo.isCallout();
				});
				promotion = promos[0];
			}

			if(!promotion) {
				if (!$('body').hasClass('cq_isEditMode')) {
					mod.$ctx.addClass('hidden');
				} else {
					mod.$textfield.text(mod.defaultText);
				}
				return;
			}

			mod.$textfield.text(promotion.getName());
			mod.$ctx.removeClass('hidden');
		}
	});

}(window.Tc.$, window.Tc.Module));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PromoBadge.js
// module id = 172
// module chunks = 0